import { SimbriefFlightplan } from '../types';

export const DemoFlightPlan: SimbriefFlightplan = {
  fetch: {
    userid: 'demouser',
    status: 'Success',
    time: '0.0176',
  },
  params: {
    request_id: '12345678',
    user_id: '00000',
    time_generated: '000000000000',
    ofp_layout: 'LIDO',
    airac: '2213',
    units: 'kgs',
  },
  general: {
    release: '1',
    icao_airline: 'DEMO',
    flight_number: '001',
    is_etops: '0',
    dx_rmk: 'PLANNED OPTIMUM FLIGHT LEVEL',
    is_detailed_profile: '1',
    cruise_profile: 'CI 6',
    climb_profile: '250/300/78',
    descent_profile: '78/300/250',
    alternate_profile: 'CI0',
    reserve_profile: 'RES',
    costindex: '6',
    cont_rule: '15 MIN',
    initial_altitude: '31000',
    stepclimb_string: 'CYYZ/0310',
    avg_temp_dev: '9',
    avg_tropopause: '39324',
    avg_wind_comp: '32',
    avg_wind_dir: '203',
    avg_wind_spd: '047',
    gc_distance: '274',
    route_distance: '328',
    air_distance: '301',
    total_burn: '2334',
    cruise_tas: '423',
    cruise_mach: '.71',
    passengers: '164',
    route: 'DCT DCT DCT DCT',
    route_ifps: 'DCT DCT DCT DCT',
    route_navigraph: 'DCT DCT DCT DCT',
  },
  origin: {
    icao_code: 'CYYZ',
    iata_code: 'YYZ',
    elevation: '569',
    pos_lat: '43.676072',
    pos_long: '-79.630475',
    name: 'LESTER B PEARSON INTL',
    timezone: '-4',
    plan_rwy: '23',
    trans_alt: '18000',
    trans_level: '18000',
    metar:
      'CYYZ 180100Z 17008KT 140V210 15SM SCT040 SCT140 BKN210 23/17 A2962 RMK SC3AC1CS2 SLP030 DENSITY ALT 2000FT',
    metar_time: '2023-08-18T01:00:00Z',
    metar_category: 'vfr',
    metar_visibility: '9999',
    metar_ceiling: '9999',
    taf: 'CYYZ 172340Z 1800/1906 19012G22KT P6SM BKN040 BKN230\nFM180100 20012G22KT P6SM -SHRA BKN030 OVC240\nTEMPO 1801/1804 4SM SHRA BR BKN020 OVC080\nPROB40 1801/1804 2SM +TSRA BR BKN012 OVC030CB\nFM180400 25012KT P6SM SCT020 BKN040 BKN100\nTEMPO 1804/1807 5SM -SHRA BR BKN015 OVC030\nFM180700 25012KT P6SM BKN020 BKN060\nTEMPO 1807/1816 SCT025 BKN060\nBECMG 1807/1809 29010KT\nFM181600 29015G25KT P6SM -SHRA BKN020 BKN050\nFM182200 30015G25KT P6SM BKN025\nBECMG 1900/1902 32012KT\nRMK NXT FCST BY 180300Z',
    taf_time: '2023-08-17T23:40:00Z',
    atis: {
      network: 'vatsim',
      issued: '2023-08-18T01:00:00Z',
      letter: 'D',
      phonetic: 'DELTA',
      type: 'DEP/ARR',
      message:
        'CYYZ INFORMATION D, WEATHER AT 0100Z, 17016G21KT, 15SM,,, FEW060',
    },
  },
  destination: {
    icao_code: 'CYUL',
    iata_code: 'YUL',
    elevation: '118',
    pos_lat: '45.470464',
    pos_long: '-73.740933',
    name: 'PIERRE ELLIOTT TRUDEAU INTL',
    timezone: '-4',
    plan_rwy: '24R',
    trans_alt: '18000',
    trans_level: '18000',
    metar:
      'CYUL 180100Z 15016G21KT 15SM FEW060 BKN110 BKN250 23/19 A2975 RMK SC1AC4CI1 SLP077 DENSITY ALT 1300FT',
    metar_time: '2023-08-18T01:00:00Z',
    metar_category: 'vfr',
    metar_visibility: '9999',
    metar_ceiling: '9999',
    taf: 'CYUL 172340Z 1800/1824 15015G25KT P6SM SCT040 BKN110\nFM180800 16012KT P6SM -SHRA SCT020 BKN040\nFM181000 18015G25KT 2 1/2SM SHRA BR BKN012 OVC040\nPROB30 1810/1813 VRB15G30KT 1 1/2SM +TSRA BR BKN008 OVC020CB\nFM181300 22012KT 3SM -SHRA BR SCT006 OVC012\nFM181500 25015KT 6SM -SHRA BR BKN012 OVC030\nPROB30 1817/1819 2SM TSRA BR BKN030CB\nFM181900 22012G22KT P6SM -SHRA BKN030 OVC040\nFM182100 25015G25KT P6SM BKN020 OVC040\nRMK NXT FCST BY 180300Z',
    taf_time: '2023-08-17T23:40:00Z',
    atis: {
      network: 'vatsim',
      issued: '2023-08-18T01:00:00Z',
      letter: 'D',
      phonetic: 'DELTA',
      type: 'DEP/ARR',
      message:
        'CYUL INFORMATION Z, WEATHER AT 0100Z, 15015G25KT, 15SM,,, FEW060',
    },
  },
  alternate: {
    icao_code: 'CYQB',
    iata_code: 'YQB',
    elevation: '244',
    pos_lat: '46.791197',
    pos_long: '-71.393314',
    name: 'JEAN LESAGE INTL',
    timezone: '-4',
    plan_rwy: '11',
    trans_alt: '18000',
    trans_level: '18000',
    metar:
      'CYQB 180100Z 13009KT 15SM SCT057 BKN100 22/18 A2986 RMK SC4AC1 SLP114 DENSITY ALT 1200FT',
    metar_time: '2023-08-18T01:00:00Z',
    metar_category: 'vfr',
    metar_visibility: '9999',
    metar_ceiling: '9999',
    taf: 'CYQB 172340Z 1800/1824 14009KT P6SM BKN040 BKN100\nBECMG 1800/1802 08006KT\nFM180300 08006KT P6SM SCT020 OVC040\nTEMPO 1803/1806 BKN020 OVC040\nFM180600 08005KT P6SM BKN020 OVC040\nFM181500 09012G22KT P6SM -SHRA BKN030 OVC060\nFM181700 14008G18KT 3SM SHRA BR BKN020 OVC030\nPROB30 1817/1822 VRB15G25KT 2SM TSRA BR BKN020 OVC040CB\nFM182200 27005KT 4SM -SHRA BR BKN012 OVC025\nRMK NXT FCST BY 180600Z',
    taf_time: '2023-08-17T23:40:00Z',
    atis: {
      network: 'vatsim',
      issued: '2023-08-18T01:00:00Z',
      letter: 'D',
      phonetic: 'DELTA',
      type: 'DEP/ARR',
      message: 'CYQB INFORMATION D, WEATHER AT 0100Z, 14009KT, 15SM,,, FEW060',
    },
  },
  fuel: {
    taxi: '230',
    enroute_burn: '2334',
    contingency: '682',
    alternate_burn: '1374',
    reserve: '1103',
    etops: '0',
    extra: '0',
    min_takeoff: '5493',
    plan_takeoff: '5493',
    plan_ramp: '5723',
    plan_landing: '3159',
    avg_fuel_flow: '2726',
    max_tanks: '19323',
  },
  weights: {
    oew: '43780',
    pax_count: '164',
    bag_count: '164',
    pax_count_actual: '164',
    bag_count_actual: '163',
    pax_weight: '79.379',
    bag_weight: '24.948',
    freight_added: '0',
    cargo: '4091',
    payload: '17109',
    est_zfw: '60889',
    max_zfw: '62500',
    est_tow: '66382',
    max_tow: '68334',
    max_tow_struct: '78000',
    tow_limit_code: 'L',
    est_ldw: '64048',
    max_ldw: '66000',
    est_ramp: '66612',
  },
  images: {
    directory: 'demomodenolink',
    map: [
      {
        name: 'Demo Mode',
        link: 'nonavail',
      },
    ],
  },
  links: {
    skyvector: 'http://skyvector.com/?fpl= CYYZ CYUL',
  },
  aircraft: {
    icaocode: 'A320',
    iatacode: '320',
    base_type: 'A320',
    icao_code: 'A320',
    iata_code: '320',
    name: 'A320-200',
    reg: 'N320SB',
    fin: '205',
    equip: 'M-SDE3FGHIRWY/LB1',
    fuelfact: '1',
    fuelfactor: '1',
    max_passengers: '180',
    internal_id: 'A320',
    is_custom: '0',
  },
  "prefile": {
    "vatsim": {
      "name": "VATSIM",
      "site": "my.vatsim.net",
      "link": "",
      "form": ""
    },
    "ivao": {
      "name": "IVAO",
      "site": "fpl.ivao.aero",
      "link": "",
      "form": ""
    },
    "pilotedge": {
      "name": "PilotEdge",
      "site": "www.pilotedge.net",
      "link": "",
      "form": ""
    },
    "poscon": {
      "name": "POSCON",
      "site": "hq.poscon.net",
      "link": "",
      "form": ""
    }
  },
};
